export default __webpack_public_path__ + "static/media/601.84e87561.png";